import { getErrorMessage } from "@/helpers/handleErrorResponse";
import { CustomError } from "@/utils/errors";

import axiosInstance from "../config";

export type FeedbackRating = "positive" | "negative";
export type FeedbackReferenceType = "ai_analysis_summary";

export interface FeedbackPayload {
  reference_id: string;
  reference_type: FeedbackReferenceType;
  rating: FeedbackRating;
  reason: string | null;
  comment?: string;
}

export interface DeleteFeedbackPayload {
  reference_id: string;
  reference_type: FeedbackReferenceType;
}

export const postFeedback = async (payload: FeedbackPayload) => {
  try {
    const { data } = await axiosInstance.post("/v1/feedback", payload);
    return data;
  } catch (error) {
    const { status, message } = getErrorMessage(error);
    throw new CustomError(message, status);
  }
};

export const deleteFeedback = async ({
  reference_id,
  reference_type
}: DeleteFeedbackPayload) => {
  try {
    const { data } = await axiosInstance.delete(
      `/v1/feedback/${reference_type}/${encodeURIComponent(reference_id)}`
    );
    return data;
  } catch (error) {
    const { status, message } = getErrorMessage(error);
    throw new CustomError(message, status);
  }
};
